import { useApiUser } from "../store/Me";

export const AuthWrapper = (props: {
  noAuth: React.ReactNode | JSX.Element;
  loading: React.ReactNode | JSX.Element;
  auth: React.ReactNode | JSX.Element;
}) => {
  const { profile } = useApiUser();
  // console.log("profile ", profile);

  if (profile.loading === true) return <>{props.loading}</>;
  if (profile.user === null) return <>{props.noAuth}</>;

  return <>{props.auth}</>;
};
